import {
  ComplianceInstitutionProfileInput,
  ComplianceJointProfileInput,
  InstitutionAccountTypeEnum,
  JointAccountTypeEnum,
} from "../../../graphql/supergraphTypes";
import {
  buildJointDomicileAddresses,
  getSafeDate,
  profileAddressesToAddresses,
} from "../../common/ProfileManagement/profile_utils";
import { DeclarationProfileType } from "../../profile/ProfileDeclaration/types";
import { JointFormValues } from "./JointDetailsForm/types";

export const prepareJointAccountPayload = (
  caseId: number,
  values: JointFormValues,
): ComplianceJointProfileInput => {
  return {
    caseId: caseId,
    legalBusinessName: values.legalBusinessName || "",
    accountType: values.accountType as JointAccountTypeEnum,
    amlEntityId: 1,
    addresses: buildJointDomicileAddresses(values.country),
  };
};

/**
 * Legacy joint payload used when the `guidedProfileCreation` flag is off.
 * Joint profiles are persisted through the institution mutation in this path.
 */
export const prepareLegacyJointAccountPayload = (
  caseId: number,
  values: JointFormValues,
  profile?: DeclarationProfileType | null,
): ComplianceInstitutionProfileInput => {
  const addresses = profileAddressesToAddresses(profile?.addresses);

  const domicileAddress = {
    ...(addresses[0] || {}),
    country: values.country,
    addressType: "domicile",
  };

  return {
    caseId: caseId,
    legalBusinessName: values.legalBusinessName || "",
    accountType: values.accountType as InstitutionAccountTypeEnum,
    dateOfFormation: getSafeDate(profile?.dateOfOrganization),
    taxId: profile?.taxIdUnencrypted,
    taxIdType: profile?.taxIdType,
    amlEntityId: profile?.amlEntityTypeId || 1, // Defaulting to Natural person AML entity type
    addresses: [domicileAddress],
  };
};
